//@flow
import React from 'react';
import Link from '../../../components/Link';
import { SubPageLinks } from '../config/subPages';

const renderItems = () => {
  return SubPageLinks.map((item, index) => (
    <li role="menuitem" key={index}>
      <Link to={item.link} external={true}>{item.label}</Link>
    </li>
  ));
};

export default function OfficeSubPagesDropdown() {
  return (
    <div tabIndex="0" role="tabpanel" className="nb-dropdown">
      <div className="nb-dropdown-label-container">
        <Link to="#" className="nb-dropdown-label-link">
          <div className="nb-dropdown-label">
            Use Cases
          </div>
          <div className="nb-dropdown-icon">
          </div>
        </Link>
      </div>
      <ul aria-hidden="false" aria-label="submenu" className="nb-dropdown-items">
        {renderItems()}
      </ul>
    </div>
  );
}
